import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as profileActions from '../actions/profileActions';
import Controls from '../../util/controls';
import MerchantDetails from '../components/merchantDetails';

class ProfilePage extends Component {

  constructor(props) {
    super(props);

    this.onTradingHoursChange = this.onTradingHoursChange.bind(this);
    this.postTradingHours = this.postTradingHours.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { actions } = this.props;
    
    if (nextProps.core.merchantInfo && this.props.core.merchantInfo !== nextProps.core.merchantInfo)
      actions.getTradingHours(nextProps.core.merchantInfo.clientId, nextProps.core.merchantInfo.merchantId);
  }

  componentDidMount() {
    const { actions, core } = this.props;

    if (core.merchantInfo)
      actions.getTradingHours(core.merchantInfo.clientId, core.merchantInfo.merchantId);
  }
  

  onTradingHoursChange(key, hours) {
    const { actions, profile } = this.props;

    actions.updateTradingHours({ 
      ...profile.tradingHours, 
      [key]: { ...profile.tradingHours[key], ...hours, openHours: hours.value } 
    });
  }

  postTradingHours() {
    const { actions, core, profile } = this.props;
    
    actions.postTradingHours(core.merchantInfo.clientId, core.merchantInfo.terminalId, profile.tradingHours);
  }
  
  render() {
    let { mode } = this.props.routeParams;

    if (!mode) {
      mode = 'view';
    }
    return (
      <div>
        {mode === 'view' && (this.props.core.merchantInfo ? (
          <MerchantDetails 
            details={this.props.core.merchantInfo} 
            tradingHours={this.props.profile.tradingHours} 
            tradingHoursLoading={this.props.profile.tradingHoursLoading}
            onTradingHoursChange={this.onTradingHoursChange}
            onTradingHoursSubmit={this.postTradingHours} />
        ) : <Controls.LoadingPanel />)}
        {/*{mode === 'edit' && <AddressEdit address={this.props.core} />}*/}
        {mode === 'edit' && <MerchantDetailsEdit details={this.props.core.merchantInfo} />}
      </div>
    );
  }

}

function mapStateToProps(state) {
  return {
    profile: state.profile,
    core: state.core
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(profileActions, dispatch)
  };
}


export default connect(mapStateToProps, mapDispatchToProps)(ProfilePage);



// WEBPACK FOOTER //
// ./app/profile/containers/profilePage.js